import { defer } from 'rxjs';
import Vue from 'vue';
import Component from 'vue-class-component';

import { matchError } from '@monjin/data/util';

import { validateShare } from '@api/validateShare';
import WithRender from './ParticipantJoin.html';

const SHARE_PLAYBACK_INVITE_JOIN_SESSION_KEY = 'sharePlaybackInviteFailedCount';

@WithRender
@Component({})
export class SharePlaybackInvite extends Vue {
    public participantCode: string = '';

    // 0 - No error, 1 - No code, 2 - Invalid code, 3 - Other error
    public errorCode: 0 | 1 | 2 | 3 = 0;

    public loggingOutWarning: string = '';
    public loading: boolean = false;
    public iAmNotRobot: boolean = false;
    public shareId: number = 0;

    public get siteKey(): string {
        // @ts-ignore
        return window.Monjin.captchaKey;
    }

    public get showCaptcha(): boolean {
        return this.sharePlaybackInviteFailedCount >= 2 && !!this.siteKey;
    }

    public get isValidCaptcha(): boolean {
        return this.showCaptcha ? this.iAmNotRobot : true;
    }

    public get disabled(): boolean {
        return this.loading || !this.isValidCaptcha;
    }

    public get sharePlaybackInviteFailedCount(): number {
        return parseInt(sessionStorage.getItem(SHARE_PLAYBACK_INVITE_JOIN_SESSION_KEY) || '0', 10);
    }

    public set sharePlaybackInviteFailedCount(count) {
        sessionStorage.setItem(SHARE_PLAYBACK_INVITE_JOIN_SESSION_KEY, (count).toString());
        this.sharePlaybackInviteFailedCount = count;
    }

    public created() {
        if (this.$route.params.shareCode) {
            this.participantCode = this.$route.params.shareCode;
        }

        if (this.$route.query.shareId) {
            this.shareId = parseInt(this.$route.query.shareId as string, 10);
        }
    }

    public setIAmNotRobot(value: boolean) {
        this.iAmNotRobot = value;
    }

    public onPinChange(joinCode: string) {
        this.errorCode = 0;
    }

    public onConfirm() {
        this.loggingOutWarning = '';

        if (!this.participantCode) {
            this.errorCode = 1;
        } else if (this.participantCode.length !== 6) {
            this.errorCode = 2;
        } else {
            const code = this.participantCode;
            this.errorCode = 0;

            this.loading = true;

            const operation = defer(() => validateShare(this.participantCode));

            this.$subscribeTo(operation,
                (response: any) => {
                    this.loading = false;

                    if (response.isExpired) {
                        this.$snackbar.error({ message: 'This link is already expired. Please contact the sender of this link.' });

                        return;
                    }

                    let location = `/playback/share/${this.participantCode}`;
                    if (this.shareId > 0) {
                        location = `${location}/interview/${this.shareId}`;
                    }
                    window.location.href = location;
                },
                matchError({
                    // TODO: Add 500 code in ResponseErrorPatterns
                    // @ts-ignore
                    500: () => {
                        this.$snackbar.error({ message: 'The code you have entered is invalid.' });
                        this.loading = false;
                    },
                    anyError: (anyerror: any) => {
                        this.$snackbar.error({ message: anyerror.message || 'Validation failed.' });
                        this.loading = false;
                    }
                }));
        }
    }
}
